import { uploadFoto } from "../services/fetch";

/**
 * Resolve o campo de foto antes de um POST.
 * - Se for File: faz upload e retorna o _id gerado.
 * - Caso contrário: retorna o valor original sem alteração.
 */
async function resolverFotoParaCriar(foto) {
  if (foto instanceof File) {
    return uploadFoto.criar(foto);
  }
  return foto;
}

/**
 * Resolve o campo de foto antes de um PUT.
 * - logoId null + foto File   → upload novo
 * - logoId existente + File   → substituição (atualizar)
 * - logoId === foto._id       → sem mudança, devolve só o id
 * - demais casos              → retorna o valor original
 */
async function resolverFotoParaAtualizar(fotoId, foto) {
  if (fotoId === null && foto instanceof File) {
    return uploadFoto.criar(foto);
  }
  if (fotoId && foto instanceof File) {
    return uploadFoto.atualizar(fotoId, foto);
  }
  if (fotoId && foto === null) {
    return uploadFoto.deletar(fotoId);
  }
  if (fotoId && fotoId === foto?._id) {
    return fotoId;
  }
  return foto;
}

export { resolverFotoParaCriar, resolverFotoParaAtualizar };
